<template>
  <div v-if="guestProfiles" style="min-height: 400px">
    <vs-row vs-justify="space-between">
      <vs-col vs-w="10">
        <h3 class="mr-4 mb-4">Guest profiles</h3>
        <p>Select a venue to see all guests for that specific venue.</p>
      </vs-col>
    </vs-row>

    <vs-row>
      <VenueSelector v-model="selectedVenueId" :filterCountries="[activeCountry.name]" class="mt-4 max-w-md" />
    </vs-row>

    <div v-if="selectedVenueId && !isSearching" class="mt-6">
      <vs-row>
        <p>Showing {{ queryNumGuests }} guests with the current search</p>
      </vs-row>

      <div class="data-list-container data-list-list-view">
        <vs-table
          ref="table"
          class="mt-8 mb-8 pb-8"
          v-model="selected"
          pagination
          @change-page="handleChangePage"
          :sst="true"
          :max-items="pageSize"
          :total="queryNumGuests"
          :data="guestProfiles"
          :noDataText="
            !hasSearched ? 'Type name, e-mail or phone in the search field and press enter to find a guest' : 'No guests matched'
          "
          @selected="onClicked(selected.id)"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-input type="search" v-model="query" v-on:keyup.enter="handleSearch" border placeholder="Search" class="search mr-2" />
          </div>

          <!-- ITEMS PER PAGE -->
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Venue</vs-th>
            <vs-th>E-mail</vs-th>
            <vs-th>Last active</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <p class="product-name font-medium truncate">
                    {{ tr.displayName }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ tr.venueName }}
                  </p>
                </vs-td>

                <vs-td>
                  <vs-chip color="primary" class="product-order-status">
                    {{ tr.email }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ moment(tr.lastActive).format("DD-MM-YYYY") }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <Loading v-if="isSearching" />
      </div>
    </div>

    <!-- table -->
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  components: { VenueSelector },
  data() {
    return {
      moment,
      query: "",
      hasSearched: false,
      selected: [],

      currentPage: 1,
      pageSize: 20,
      queryNumGuests: 0,
      overallNumGuests: 0,

      selectedVenueId: null
    };
  },
  watch: {
    selectedVenueId: function (newVal, oldVal) {
      this.performSearch();
    }
  },
  methods: {
    handleChangePage(page) {
      this.currentPage = page;
      console.log("Changed page to", page);
      this.performSearch();
    },

    handleSearch(query) {
      // When the query changes, we want to recount how many quests are targeted by the search
      this.currentPage = 1;
      this.performSearch();

      this.hasSearched = this.query != "";
    },

    async performSearch() {
      var result = await this.$store.dispatch("userProfiles/queryUserProfilesByVenue", {
        country: this.activeCountryId,
        venueId: this.selectedVenueId,
        query: this.query,
        top: this.pageSize,
        skip: (this.currentPage - 1) * this.pageSize
      });

      if (result.count != null) {
        this.queryNumGuests = result.count;
      }
    },

    onClicked(id) {
      this.$router
        .push({
          name: "crm-guest-profile",
          params: { id: id }
        })
        .catch(e => {
          console.log("Profile lookup error", e);
        });
    }
  },
  computed: {
    ...mapGetters({
      queryResult: "userProfiles/queryUserProfilesByVenueResult",
      isSearching: "userProfiles/isSearching",
      activeCountryId: "venues/activeCountryId",
      activeCountry: "venues/activeCountry"
    }),

    guestProfiles() {
      console.log("QUERY RESULT venues", this.queryResult);
      if (this.queryResult == null) return [];
      const result = this.queryResult.results;
      var emptyArray = Array((this.currentPage - 1) * this.pageSize);
      return [...emptyArray, ...result];
    }
  }
};
</script>
